/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Practice_Score_Needs_ImprovementInputs */

const en_interview_practice_score_needs_improvement = /** @type {(inputs: Interview_Practice_Score_Needs_ImprovementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Needs improvement`)
};

const de_interview_practice_score_needs_improvement = /** @type {(inputs: Interview_Practice_Score_Needs_ImprovementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbesserungsbedarf`)
};

const fr_interview_practice_score_needs_improvement = /** @type {(inputs: Interview_Practice_Score_Needs_ImprovementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À améliorer`)
};

const es_interview_practice_score_needs_improvement = /** @type {(inputs: Interview_Practice_Score_Needs_ImprovementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Necesita mejorar`)
};

const it_interview_practice_score_needs_improvement = /** @type {(inputs: Interview_Practice_Score_Needs_ImprovementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Da migliorare`)
};

const nl_interview_practice_score_needs_improvement = /** @type {(inputs: Interview_Practice_Score_Needs_ImprovementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbetering nodig`)
};

const pl_interview_practice_score_needs_improvement = /** @type {(inputs: Interview_Practice_Score_Needs_ImprovementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wymaga poprawy`)
};

const fi_interview_practice_score_needs_improvement = /** @type {(inputs: Interview_Practice_Score_Needs_ImprovementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kehitettävää`)
};

const da_interview_practice_score_needs_improvement = /** @type {(inputs: Interview_Practice_Score_Needs_ImprovementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kan forbedres`)
};

const sv_interview_practice_score_needs_improvement = /** @type {(inputs: Interview_Practice_Score_Needs_ImprovementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kan förbättras`)
};

/**
* | output |
* | --- |
* | "Needs improvement" |
*
* @param {Interview_Practice_Score_Needs_ImprovementInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_practice_score_needs_improvement = /** @type {((inputs?: Interview_Practice_Score_Needs_ImprovementInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Practice_Score_Needs_ImprovementInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_practice_score_needs_improvement(inputs)
	if (locale === "fr") return fr_interview_practice_score_needs_improvement(inputs)
	if (locale === "es") return es_interview_practice_score_needs_improvement(inputs)
	if (locale === "it") return it_interview_practice_score_needs_improvement(inputs)
	if (locale === "nl") return nl_interview_practice_score_needs_improvement(inputs)
	if (locale === "pl") return pl_interview_practice_score_needs_improvement(inputs)
	if (locale === "fi") return fi_interview_practice_score_needs_improvement(inputs)
	if (locale === "da") return da_interview_practice_score_needs_improvement(inputs)
	if (locale === "sv") return sv_interview_practice_score_needs_improvement(inputs)
	return en_interview_practice_score_needs_improvement(inputs)
});